import React, { useEffect, useState } from "react";
import Accordion from "../components/accordion";
import MetaTag from "../components/CommonSections/MetaTag";
import PageLoader from "../components/home/pageload";
import HeaderTitle from "../components/headerTitle";
import ServiceSchema from "../components/CommonSections/serviceSchema";
import FrontVideo from "../components/homevideo";
import Information from "../components/CommonSections/Information";
import WhatWeOffer from "../components/CommonSections/WhatWeOffer";
import Advantage from "../components/CommonSections/Advantage";
import Partners from "../components/CommonSections/Partners";
import CtaBanner from "../components/CommonSections/CtaBanner";
import axios from "axios";
import { API_BASE_URL } from "../config/config";

const PAGE_KEY = "sovereign_ai_cloud_services";

export default function SovereignAiCloudServices() {
  const [sovereignServicesData, setSovereignServicesData] = useState(null);
  const [partnersData, setPartnersData] = useState(null);
  const [sovereignSettingsData, setSovereignSettingsData] = useState(null);

  useEffect(() => {
    axios
      .post(`${API_BASE_URL}/api/sovereignaicloudservices/getSovereignAiCloudServices`)
      .then((response) => {
        setSovereignServicesData(response);

        const generalSettingsData =
          response?.data?.data?.general_settings?.general_settings_data;
        const partnersData =
          generalSettingsData.find(
            (item) => item.tag === "sovereign_ai_cloud_services_partners",
          ) || null;
        const sovereignAdvantageData =
          generalSettingsData.find(
            (item) => item.tag === "sovereign_ai_cloud_advantage",
          ) || null;

        const partnersResponse = JSON.parse(partnersData?.response || "{}");
        const sovereignResponse = JSON.parse(
          sovereignAdvantageData?.response || "{}",
        );
        sovereignResponse.advantages = sovereignResponse;
        setSovereignSettingsData(sovereignResponse);
        setPartnersData(partnersResponse);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const getFaqSchema = () => {
    const faqData =
      sovereignServicesData?.data?.data?.[PAGE_KEY]?.faq_info_data || [];
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqData.map((faq) => ({
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.answerData || faq.answer.replace(/<[^>]*>?/gm, ""),
        },
      })),
    };
  };

  const bannerData =
    sovereignServicesData?.data?.data?.[PAGE_KEY]?.[
      `${PAGE_KEY}_banner_data`
    ]?.[0];

  return (
    <>
      {sovereignServicesData === null ? (
        <PageLoader />
      ) : (
        <>
          <ServiceSchema
            title={bannerData?.title}
            url="https://ishantechnologies.com/sovereign-ai-and-cloud-services"
          />
          <MetaTag data={sovereignServicesData} pageKey={PAGE_KEY} />
          <div className="page_heading responsive_heading">
            <div className="container">
              <HeaderTitle
                headerTitledata={sovereignServicesData}
                pageKey={PAGE_KEY}
              />
            </div>
          </div>

          <div
            className={`video hero-banner ${
              !bannerData?.banner_title && !bannerData?.banner_img_desc
                ? "no-content"
                : ""
            }`}
          >
            <FrontVideo homeData={sovereignServicesData} pageKey={PAGE_KEY} />

            <div className="banner-content ">
              {bannerData?.banner_title && (
                <h2 className="home-heading">{bannerData.banner_title}</h2>
              )}

              {bannerData?.banner_img_desc && (
                <p className="para">{bannerData.banner_img_desc}</p>
              )}

              {bannerData?.button_img_name && (
                <a href={bannerData.button_url}>
                  <button className="button hero-btn">
                    {bannerData.button_img_name}
                  </button>
                </a>
              )}
            </div>
          </div>

          <Information
            homeData={
              sovereignServicesData?.data?.data?.[PAGE_KEY]?.[
                `${PAGE_KEY}_information_data`
              ]?.[0]?.description
            }
          />

          <WhatWeOffer
            title={sovereignSettingsData?.what_we_offer}
            data={
              sovereignServicesData?.data?.data?.[PAGE_KEY]?.[
                `${PAGE_KEY}_offer_data`
              ]
            }
          />

          <Advantage
            title={sovereignSettingsData?.advantages}
            data={
              sovereignServicesData?.data?.data?.[PAGE_KEY]?.[
                `${PAGE_KEY}_advantages_data`
              ]
            }
          />

          <Partners
            title={partnersData?.title}
            data={
              sovereignServicesData?.data?.data?.[PAGE_KEY]?.partners_data
            }
          />

          {sovereignServicesData?.data?.data?.[PAGE_KEY]?.faq_info_data
            ?.length > 0 && (
            <div className="frequently section-space">
              <div className="container">
                <h2 className="supercharge-heading">
                  Frequently Asked Questions (FAQs)
                </h2>

                <script
                  type="application/ld+json"
                  dangerouslySetInnerHTML={{
                    __html: JSON.stringify(getFaqSchema()),
                  }}
                />

                <Accordion
                  items={
                    sovereignServicesData?.data?.data?.[PAGE_KEY]
                      ?.faq_info_data
                  }
                />
              </div>
            </div>
          )}

          <CtaBanner
            bannerData={
              sovereignServicesData?.data?.data?.[PAGE_KEY]?.[
                `${PAGE_KEY}_cta_banner_data`
              ]
            }
          />
        </>
      )}
    </>
  );
}
